import React from 'react';
import Link from 'next/link';
import { Container } from './styles';
import Image from 'next/legacy/image';
import LogoImage from './assets/logo_dge.png';
import { Tabs } from '@/components/ranking/molecules/Header/Tabs';
import { FormsHeader } from '@/components/ranking/molecules/Header/Forms';
import { Hamburguer } from '@/components/ranking/molecules/Header/Hamburguer';

export const Header: React.FC = () => {
  return (
    <Container id='header'>
      <Link href="/">
        <div className='boxLogo'>
          <div className='hidden'>
            <Image src={LogoImage} />
          </div>
          <div className='hiddenMobile'>
            <Image src={LogoImage}  width={170} height={48}/>
          </div>
        </div>
      </Link>
      <Hamburguer />
      <Tabs />
      <FormsHeader />
    </Container >
  );
};
